import { withLabels } from '../../hoc';
import { TextField as StandardTextField } from './TextField';
export const TextField = withLabels(StandardTextField);
TextField.displayName = 'TextField';
//# sourceMappingURL=index.js.map